// OPS Occult Library comparative visual archive v6 — Aetites source pack.
(()=>{
  const TITLE='aetites';
  const SOURCES=[
    {
      date:'1483 (as cited by Kunz’s 1915 reproduction)',
      period:'Late 15th century',
      creator:'Johannis de Cuba (traditional attribution); woodcut artist unknown',
      work:'Ætites / eagle-stone, from Ortus Sanitatis',
      page:'Reproduced on p. 175 of George Frederick Kunz, The Magic of Jewels and Charms (1915); caption cites Strassburg, 1483',
      institution:'Project Gutenberg / Internet Archive scan; source woodcut from Ortus Sanitatis',
      collection:'George Frederick Kunz, The Magic of Jewels and Charms, 1915',
      imageUrl:'https://www.gutenberg.org/cache/epub/66583/images/i_175.jpg',
      sourceUrl:'https://www.gutenberg.org/cache/epub/66583/pg66583-images.html',
      rights:'Public-domain historical woodcut; Project Gutenberg edition is public domain in the USA',
      rightsUrl:'https://www.gutenberg.org/ebooks/66583',
      attribution:'Johannis de Cuba (traditional attribution), Ætites, Ortus Sanitatis, Strassburg, 1483 (as cited by Kunz), reproduced in George Frederick Kunz, The Magic of Jewels and Charms, 1915, p. 175. Public-domain scan via Project Gutenberg.',
      note:'An early printed image of the eagle-stone tradition. The archive preserves Kunz’s stated 1483 attribution rather than silently normalising the complicated edition history of Ortus/Hortus Sanitatis.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'1565',
      period:'Mid-16th-century Renaissance natural history',
      creator:'Conrad Gessner (1516–1565); woodcut cutter not identified',
      work:'Aetites figures, from De rerum fossilium, lapidum et gemmarum maxime',
      page:'fol. 10v',
      institution:'Smithsonian Libraries and Archives / Biodiversity Heritage Library',
      collection:'Conradi Gesneri De rerum fossilium, lapidum et gemmarum maxime, 1565',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/De_rerum_fossilium-010v-1.png?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:De_rerum_fossilium-010v-1.png',
      rights:'Public domain historical work; Smithsonian digitisation released CC0 1.0',
      rightsUrl:'https://creativecommons.org/publicdomain/zero/1.0/',
      attribution:'Conrad Gessner, Aetites figures, De rerum fossilium, 1565, fol. 10v. Smithsonian Libraries and Archives / BHL; public-domain scan, CC0 institutional digitisation; crop via Wikimedia Commons.',
      note:'Gessner moves the eagle-stone into illustrated comparative mineralogy. Modern scholarship identifies aetites on fol. 10v, making this a useful bridge between inherited lapidary lore and specimen-based natural history.',
      verifiedOn:'2026-09-13'
    },
    {
      date:'Object date not recorded; photographed 1958',
      period:'Historic amulet; 20th-century museum documentation',
      creator:'Unknown maker; photographed for the Wellcome Historical Medical Museum',
      work:'“Aetites” substance mounted in silver as a pendant',
      page:'Wellcome image M0016861; archive group WT/D/1/20/1/151/82',
      institution:'Wellcome Collection, London',
      collection:'Wellcome Trust Corporate Archive / historical medical museum photographic image series',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/%27Aetites%27%2C_substance_mounted_in_silver_as_a_pendant._Wellcome_M0016861.jpg?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:%27Aetites%27,_substance_mounted_in_silver_as_a_pendant._Wellcome_M0016861.jpg',
      rights:'Creative Commons Attribution 4.0 International (CC BY 4.0)',
      rightsUrl:'https://creativecommons.org/licenses/by/4.0/',
      attribution:'“Aetites” substance mounted in silver as a pendant, maker/date not recorded; Wellcome image M0016861, photographed/documented 1958. Wellcome Collection. CC BY 4.0.',
      note:'Unlike printed descriptions, this record shows the eagle-stone as a wearable amulet. The catalogue connects M0016861 with promoting childbirth; because the object’s manufacture date is not stated, the archive leaves it undated rather than inventing a century.',
      verifiedOn:'2026-09-13'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v6-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
